import { Outlet } from 'react-router-dom';

const DefaultLayout = () => {
  return (
    <section className="layout">
      <Outlet />
    </section>
  );
};

export default DefaultLayout;
